import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './Onboarding.scss';
import onboardingService from '../../services/OnboardingService';
import AppLoading from '../shared/loading/AppLoading';
import Navbar from '../registration/navbar/Navbar';
import Footer from '../registration/footer/Footer';

const Onboarding = () => {
    const history = useHistory();
    const [packages, setPackages] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchPackages();
    }, []);

    const fetchPackages = async () => {
        setLoading(true);
        try {
            const response = await onboardingService.getPackages();
            const { success, data } = response;

            if (success && data) {
                setPackages(Array.isArray(data) ? data : []);
            }
        } catch (error) {
            console.error('Error fetching packages:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleCardClick = (url) => {
        if (!url) return;

        if (url.startsWith('http')) {
            window.location.href = url;
        } else {
            history.push(url);
        }
    };

    const renderFeatures = (features) => {
        if (!features || features.length === 0) return null;

        return features.map((feature, index) => (
            <li key={index}>
                <span className="checkmark">✓</span>
                <span className="feature-text">
                    {feature.Label} → <strong>{feature.Value}</strong>
                </span>
            </li>
        ));
    };

    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 520;
    const isMedium = windowWidth >= 521 && windowWidth <= 768;

    let imgSrc;
    if (isMobile) {
        imgSrc = "/assets/images/new-hero-bg-small.png";
    } else if (isMedium) {
        imgSrc = "/assets/images/new-hero-bg-md.png";
    } else {
        imgSrc = "/assets/images/new-hero-bg-big.png";
    }

    if (loading) {
        return (
            <div className="onboarding-page" style={{ backgroundColor: "#1E1F41" }}>
                <div className="position-center">
                    <AppLoading />
                </div>
            </div>
        );
    }

    return (
        <div className="onboarding-page" style={{ backgroundColor: "#1E1F41" }}>
            {/* Hero Section with Background */}
            <section
                className="onboarding-hero-section"
                style={{
                    backgroundImage: `url(${imgSrc})`,
                    backgroundSize: isMobile ? "contain" : "cover",
                    backgroundPosition: isMobile ? "center" : "top",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <Navbar />
                <div className="more-info-onboarding">
                    <a
                        href="https://www.atlasathlete.ai/"
                        target="_blank"
                        rel="noreferrer"
                        className="more-info-link"
                    >
                        More Information
                    </a>
                </div>

                {/* Hero Content */}
                <div className="hero-content text-center text-white w-100-percent padding-top-16px">
                    {/* Desktop text */}
                    <div className="hero-content-text-container hero-desktop-text">
                        <div className="hero-content-text-1">
                            THE STARTING LINE FOR
                        </div>
                        <div className="hero-content-text-2">EVERY ATHLETE</div>
                    </div>

                    {/* Mobile text */}
                    <div className="hero-content-text-container hero-mobile-text">
                        <div style={{ fontSize: "30px" }}>THE</div>
                        <div style={{ fontSize: "38px" }}>STARTING LINE</div>
                        <span style={{ fontSize: "36px", fontWeight: 300 }}>
                            FOR <span style={{ fontSize: "61px", fontWeight: 700 }}>
                                EVERY
                            </span>
                        </span>
                        <div style={{ fontSize: "61px", fontWeight: 700 }}>
                            ATHLETE
                        </div>
                    </div>
                </div>
            </section>

            {/* Pricing Cards Section */}
            <div className="onboarding-content">
                <div className="pricing-cards">
                    {packages.map((pkg, index) => (
                        <React.Fragment key={pkg?.Id || index}>
                            <div
                                className={`pricing-card ${pkg?.IsBestValue ? 'best-value' : 'one-time'}`}
                                onClick={() => handleCardClick(pkg?.Url)}
                            >
                                {pkg?.IsBestValue && (
                                    <div className="best-value-badge">{pkg?.Badge || 'BEST VALUE'}</div>
                                )}
                                <div className="card-content">
                                    <h2 className="card-title">
                                        <span className="option-label">Option:</span> <span className="price">{pkg?.Price}</span> {pkg?.Title}
                                        {pkg?.ValueLabel && (
                                            <> <span className="value-label">({pkg?.ValueLabel})</span></>
                                        )}
                                    </h2>
                                    <ul className="features-list">
                                        {renderFeatures(pkg?.Features)}
                                    </ul>
                                </div>
                            </div>

                            {index < packages?.length - 1 && (
                                <div className="divider-section">
                                    <div className="divider-line"></div>
                                    <span className="divider-text">OR</span>
                                    <div className="divider-line"></div>
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>

                <p className="payment-notice">
                    You'll be securely redirected to our Stripe checkout to complete your payment.
                </p>
            </div>
            <div className="">
                <Footer />
            </div>
        </div>
    );
};

export default Onboarding;
